import styled from "styled-components";
import { motion } from "framer-motion";

export const FieldDisplayContainer = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    height: 100%;
    justify-content: center;
    min-height: 614px;
    min-width: 0;
    overflow: hidden;
    padding: 0;
    padding-bottom: 48px;
    position: relative;
    width: 50%;
`
export const OutlineContainer = styled.div`
    width: 740px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;
    min-width: 740px;
`
export const FieldImg = styled(motion.img)`
    box-sizing: border-box;
    opacity: 0.2;
    width: 740px;
    height: auto;
    object-fit: contain;
    padding: 0;
    flex-shrink: 0;
    min-width: 740px;
`
export const PlacedPlayerCard = styled(motion.div)`
    align-items: center;
    display: flex;
    justify-content: center;
    position: absolute;
    transform-origin: center;
    z-index: 0;

    &:hover {
        z-index: 2;
    }
    
    @media (max-width: 1400px) {
        transform: scale(0.95);
    }

    @media (max-width: 1200px) {
        transform: scale(0.9);
    }

    @media (max-width: 1024px) {
        transform: scale(0.85);
    }

    @media (max-width: 768px) {
        transform: scale(0.75);
    }

    @media (max-width: 640px) {
        transform: scale(0.65);
    }

    @media (max-width: 480px) {
        transform: scale(0.55);
    }

    @media (max-width: 360px) {
        transform: scale(0.5);
    }
`